<div class="custom-toggle m-0 p-0">
  <div class="form-check form-switch m-0 p-0">
    <input
      class="form-check-input m-0 p-0"
      type="checkbox"
      role="switch"
      id="flexSwitchCheckDefault"
      [(ngModel)]="value"
      [disabled]="disabled"
      (ngModelChange)="switch($event)"
    >

    @if (label) {
      <label class="form-check-label" for="flexSwitchCheckDefault">{{ label }}</label>
    }
  </div>
</div>
